import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router";

import { use } from "react";
import { AuthContext } from "../../hooks/useAuthentication";

import {
  Header as Component,
  HeaderProps,
} from "../../components/organisms/Header";
import { VERSION } from "../../settings";

/**
 * HEADER CONTAINER
 */

export const Header = () => {
  const navigate = useNavigate();
  const { auth } = use(AuthContext);
  const user = {
    name: auth?.name,
  };

  const loggedInOnlyProps = {
    hasNotice: false,
    medicalInstitutionName: undefined,
    logoutClick: async () => {
      await signOut();
      await navigate("/logout");
    },
  };
  const props: HeaderProps = {
    user,
    version: VERSION,
    ...(auth?.isLoggedIn ? loggedInOnlyProps : { logoutClick: () => null }),
  };
  return <Component {...props} />;
};
